import { EventEmitter } from 'events';
import assign from 'object-assign';
import _ from 'underscore';
import { humanize } from 'underscore.string';
import i18next from 'i18next';
import SessionStore from 'stores/SessionStore';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
import UserStore from './UserStore';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'change';
const UPDATED_PREFERENCES_TEXT = 'PREFERENCES_UPDATE_SUCCESS';
let notifications = [];
const ToastStore = assign({}, EventEmitter.prototype, {
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    /**
     * @param {function} callback
     */
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getNotifications() {
        return notifications;
    },
    getLatestNotification() {
        return _.last(notifications);
    },
    removeLatestNotification() {
        if (notifications.length) {
            notifications = notifications.slice(0, notifications.length - 1);
            this.emitChange();
        }
    },
    getUpdatedShipperTitle() {
        if (SessionStore.isAdmin()) {
            return 'SHIPPER_UPDATED';
        }
        return UPDATED_PREFERENCES_TEXT;
    },
    addNotification({ title, body, level }) {
        notifications.push({ title, body, level });
        this.emitChange();
    },
});
function getErrorCode(action) {
    const error = action.error || {};
    const lastErrorObject = error.lastErrorObject || {};
    return lastErrorObject.code;
}
function isDuplicateKeyError(action) {
    return getErrorCode(action) === 11000;
}
const getSharedShipmentFailMessage = (response) => {
    if (!response || !_.isEmpty(response)) {
        return i18next.t('SHIPMENT_SHARE_ERROR');
    }
    return i18next.t('SHIPMENT_SHARE_ERROR_REASON', { error: response.error });
};
function getOrderCancelFailMessage(error = {}) {
    const message = error.message;
    if (message === 'HAS_OPEN_SHIPMENTS') {
        return 'ORDER_FAILED_DUE_TO_OPEN_SHIPMENTS';
    }
    if (message === 'OUTSTANDING_BALANCE') {
        return 'ORDER_FAILED_DUE_TO_OUTSTANDING_BALANCE';
    }
    return 'PROBLEM_IN_CANCEL_ORDER';
}
export const showToast = (title, body, level = 'success') => {
    ToastStore.getNotifications().push({
        title,
        body,
        level,
    });
    ToastStore.emitChange();
};
ToastStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const action = payload.action || {};
    let body;
    const userMarketPreferences = UserStore.getMarketsPreference();
    const shipment = action.shipment;
    switch (action.type) {
        case ActionTypes.SHIPMENT_CANCEL_SUCCESS:
            body = i18next.t('SHIPMENT_CANCELED_MESSAGE', {
                shipmentId: action.shipment.shipment_id,
            });
            notifications.push({
                title: i18next.t('CANCELED_SHIPMENT'),
                body,
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.SHIPMENT_CANCEL_FAILURE:
            body = i18next.t('SHIPMENT_CANCELED_ERROR_MESSAGE', {
                shipmentId: action.shipment.shipment_id,
            });
            notifications.push({
                title: i18next.t('CANCELED_SHIPMENT'),
                body,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.SHIPMENT_CLOSE_SUCCESS:
            body = i18next.t('SHIPMENT_CLOSED_MESSAGE', {
                shipmentId: action.shipment.shipment_id,
            });
            notifications.push({
                title: i18next.t('CLOSED_SHIPMENT'),
                body,
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        /*
        case ActionTypes.ASSIGN_DRIVER_SUCCESS:
          body = action.driver.first_name + ' ' + action.driver.last_name + ' has been assigned to ';
          body += action.shipment.shipment_id + '.';
          notifications.push({
            title: 'Assigned Driver',
            body,
            level: 'success',
          });
          ToastStore.emitChange();
          break;
          */
        case ActionTypes.SHIPMENT_NO_LONGER_IN_EXCEPTION:
            if (_.contains(userMarketPreferences, shipment.market.code)) {
                body = i18next.t('SHIPMENT_NOT_IN_EXCEPTION', {
                    shipmentId: shipment.shipment_id,
                });
                notifications.push({
                    title: 'Phew!',
                    body,
                    level: 'success',
                });
                ToastStore.emitChange();
            }
            break;
        case ActionTypes.RECEIVE_SHIPMENT_STOP_COMPLETE_FAILURE:
            body = action.error;
            notifications.push({
                title: 'Yikes!',
                body,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_SHIPPER_FAIL: {
            body = action.error;
            const { error } = action.data.entity;
            let issues = [];
            _.map(error, (value) => {
                issues = issues.concat(value);
            });
            notifications.push({
                title: i18next.t('FAILED_TO_SAVE_ACCOUNT_DETAILS', { issues }),
                body,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.UPDATE_ADMIN_FAIL:
            notifications.push({
                title: i18next.t('ADMIN_UPDATED'),
                body: i18next.t('ADMIN_PROFILE_UPDATION_FAILED'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_ADMIN_SUCCESS:
            notifications.push({
                title: i18next.t('ADMIN_UPDATED'),
                body: i18next.t('ADMIN_PROFILE_UPDATED'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.SHIPMENT_NOW_IN_EXCEPTION:
            body = i18next.t('SHIPMENT_IN_EXCEPTION', {
                shipmentId: shipment.shipment_id,
            });
            notifications.push({
                title: 'Yikes!',
                body,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.OFFER_NOW_ACTIVE:
            body = i18next.t('SHIPMENT_IS_ACTIVE', {
                shipmentId: action.offer.shipment_id,
            });
            notifications.push({
                title: 'Yo!',
                body,
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.OFFER_NO_LONGER_ACTIVE:
            body = i18next.t('SHIPMENT_NOT_ACTIVE', {
                shipmentId: action.offer.shipment_id,
            });
            notifications.push({
                title: 'Sweet!',
                body,
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.LOGIN_FAIL:
            body = action.message;
            notifications.push({
                title: i18next.t('LOGIN_FAILED'),
                body,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.EMAIL_SENT:
            body = action.to;
            notifications.push({
                title: i18next.t('EMAIL_SENT'),
                body,
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.EMAIL_FAIL:
            body = action.to;
            notifications.push({
                title: i18next.t('EMAIL_FAILED'),
                body,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATED_SHIPPER:
            notifications.push({
                title: i18next.t(ToastStore.getUpdatedShipperTitle()),
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATED_VENDOR:
            notifications.push({
                title: i18next.t('VENDOR_UPDATED'),
                body: i18next.t('VENDOR_SUCCESSFULLY_UPDATED'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATED_SHIPPER_BILLING:
            notifications.push({
                title: i18next.t(UPDATED_PREFERENCES_TEXT),
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATED_CARRIER:
            notifications.push({
                title: i18next.t('CARRIER_UPDATED'),
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_CARRIER_FAILED:
            notifications.push({
                title: i18next.t('CARRER_UPDATE_ERROR'),
                body: isDuplicateKeyError(action)
                    ? i18next.t('EMAIL_USERNAME_TAKEN')
                    : '',
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.ADDED_CARRIER_PORTPRO_DATA:
            notifications.push({
                title: i18next.t('ADDED_CARRIER_PORTPRO_DATA'),
                body: i18next.t('NEXT_HOOKS_WERE_REGISTERED', {
                    // TODO
                    webhooks: 'hooks will be added',
                }),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.ADD_CARRIER_PORTPRO_DATA_FAILED:
            notifications.push({
                title: i18next.t('ADD_CARRIER_PORTPRO_DATA_FAILED'),
                body: action.error || i18next.t('CARRER_UPDATE_ERROR'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.CHANGED_PORTPRO_ENABLING:
            notifications.push({
                title: i18next.t('ADDED_CARRIER_PORTPRO_DATA'),
                body: i18next.t('PORTPRO_INTEGRATION_STATUS_CHANGED', {
                    status: action.enabled
                        ? i18next.t('PORTPRO_ENABLED')
                        : i18next.t('PORTPRO_DISABLED'),
                }),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.CHANGE_PORTPRO_ENABLING_FAILED:
            notifications.push({
                title: i18next.t('ADD_CARRIER_PORTPRO_DATA_FAILED'),
                body: action.error || i18next.t('CARRER_UPDATE_ERROR'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.SAVE_PORTPRO_INTEGRARION:
            notifications.push({
                title: i18next.t('CARRIER_PORTPRO_INTEGRATION_SAVED'),
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.SAVE_PORTPRO_INTEGRARION_FAILED:
            notifications.push({
                title: i18next.t('CARRIER_PORTPRO_INTEGRATION_ERROR'),
                body: i18next.t(action.error) || i18next.t('CARRER_UPDATE_ERROR'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATED_BANK_ACCOUNT:
            notifications.push({
                title: i18next.t('BANK_ACCOUNT_UPDATED'),
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_BANK_ACCOUNT_FAILED:
            body = action.data.status.code !== 500 ? action.data.entity : {};
            notifications.push({
                title: i18next.t('FAILED_TO_UPDATE_BANK_ACCOUNT'),
                body,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATED_DRIVER:
            notifications.push({
                title: i18next.t('DRIVER_UPDATED'),
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_DRIVER_FAILED:
            notifications.push({
                title: i18next.t('FAILED_TO_UPDATE_DRIVER'),
                body: isDuplicateKeyError(action)
                    ? i18next.t('EMAIL_OR_USERNAME_TAKEN')
                    : '',
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATED_USER_PASSWORD:
            notifications.push({
                title: i18next.t('PASSWORD_UPDATED'),
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATED_USER_PASSWORD_FAIL: {
            let errorMsg = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.error) || i18next.t('SOMETHING_WENT_WRONG');
            notifications.push({
                title: i18next.t('FAILED_TO_UPDATE_PASSWORD'),
                body: errorMsg,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.CREATED_DRIVER:
            notifications.push({
                title: 'Driver created',
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RECEIVE_SHIPMENT_STOP_COMPLETE_SUCCESS:
        case ActionTypes.RECEIVE_SHIPMENT_UPDATE:
            notifications.push({
                title: i18next.t('SHIPMENT_SUCCESSFULLY_SAVED'),
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RECEIVE_SHIPMENT_UPDATE_ERROR:
            notifications.push({
                title: i18next.t('SHIPMENT_UPDATE_FAILED'),
                body: '',
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_CARRIER_DOCUMENTS_SUCCESS:
            notifications.push({
                title: i18next.t('DOC_UPLOAD_SUCCESS'),
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_CARRIER_DOCUMENTS_FAIL:
            notifications.push({
                title: i18next.t('DOC_UPLOAD_ERROR'),
                body: '',
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_NOTIFICATIONS_SUCCESS:
            notifications.push({
                title: i18next.t('UPDATE_NOTIFICATION_SUCCESS'),
                body: '',
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_NOTIFICATIONS_FAIL: {
            let errorMsg = ((_b = action === null || action === void 0 ? void 0 : action.err.entity) === null || _b === void 0 ? void 0 : _b.error) || 'UPDATE_NOTIFICATION_FAILURE';
            notifications.push({
                title: i18next.t('UPDATE_NOTIFICATION_FAILURE'),
                body: i18next.t(errorMsg),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.UPLOAD_SHIPMENT_DOCUMENT_SUCCESS:
            notifications.push({
                title: i18next.t('SHIPMENT_DOC_UPLOAD'),
                body: i18next.t('SHIPMENT_BOL_UPLOAD_SUCCESS', {
                    shipmentId: action.shipmentId,
                }),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPLOAD_SHIPMENT_DOCUMENT_FAIL:
            notifications.push({
                title: i18next.t('SHIPMENT_DOC_UPLOAD'),
                body: i18next.t('BOL_UPLOAD_ERROR'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.ADD_ORDER_EQUIPMENT_FAIL:
            notifications.push({
                title: i18next.t('EQUIPMENT_ADD'),
                body: (action.error || {}).error || i18next.t('EQUIPMENT_FAILED_TO_ADD'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.ADD_ORDER_EQUIPMENT_SUCCESS:
            notifications.push({
                title: i18next.t('EQUIPMENT_ADD'),
                body: i18next.t('EQUIPMENT_ADDED_SUCCESSFULLY'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.GENERATE_CUSTOM_DELIVERY_ORDER_FAIL:
        case ActionTypes.GENERATE_DELIVERY_ORDER_FAIL:
            notifications.push({
                title: i18next.t('GENERATE_DELIVERY_ORDER'),
                body: i18next.t('DELIVERY_ORDER_GENERATED_FAILED_MESSAGE'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.GENERATE_CUSTOM_DELIVERY_ORDER_SUCCESS:
        case ActionTypes.GENERATE_DELIVERY_ORDER_SUCCESS:
            notifications.push({
                title: i18next.t('GENERATE_DELIVERY_ORDER'),
                body: i18next.t('DELIVERY_ORDER_GENERATED_SUCCESS_MESSAGE'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.GENERATE_BILL_OF_LADING_FAIL:
            notifications.push({
                title: i18next.t('GENERATE_BILL_OF_LADING'),
                body: i18next.t('PROBLEM_WHILE_GENERATION_BILL_OF_LADING'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.GENERATE_BILL_OF_LADING_SUCCESS:
            notifications.push({
                title: i18next.t('GENERATE_BILL_OF_LADING'),
                body: i18next.t('LADING_BILL_GENERATED'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.GENERATE_BILL_OF_LADING_SENT_SUCCESS:
            notifications.push({
                title: i18next.t('GENERATE_BILL_OF_LADING'),
                body: i18next.t('LADING_BILL_SENT'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.GENERATE_RATE_CONFIRMATION_FAIL:
            notifications.push({
                title: i18next.t('RATE_CONFIRMATION'),
                body: i18next.t('GENERATE_RATE_CONFIRM_ERROR'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.GENERATE_RATE_CONFIRMATION_SUCCESS:
            notifications.push({
                title: i18next.t('RATE_CONFIRMATION'),
                body: i18next.t('GENERATE_RATE_CONFIRM_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.GENERATE_RATE_CONFIRMATION_SENT_SUCCESS:
            notifications.push({
                title: i18next.t('RATE_CONFIRMATION'),
                body: i18next.t('RATE_CONFIRMATION_SENT'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.BOL_CONTACTS_NEEDED:
            notifications.push({
                title: i18next.t('GENERATE_BILL_OF_LADING'),
                body: i18next.t('ENTER_BOL_IN_SHIPPER_PROFILE_OR_ADD_MANUALLY'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.EMAIL_CUSTOM_DELIVERY_ORDER_SUCCESS:
            notifications.push({
                title: i18next.t('EMAIL_DELIVERY_ORDER'),
                body: i18next.t('DELIVERY_ORDER_SENT_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.SEND_DELIVERY_ORDER_SUCCESS:
            notifications.push({
                title: i18next.t('EMAIL_DELIVERY_ORDER'),
                body: i18next.t('DELIVERY_ORDER_SENT_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.EMAIL_DELIVERY_ORDER_FAIL:
            notifications.push({
                title: i18next.t('SEND_DELIVERY_ORDER'),
                body: i18next.t('DELIVERY_ORDER_SENT_FAILED'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.SET_DRIVER_FAIL:
            notifications.push({
                title: i18next.t('UPDATE_DRIVER'),
                body: i18next.t('CARRIER_OR_DRIVER_UPDATE_ERROR', {
                    error: humanize(action.error),
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.CANCEL_ORDER_FAIL:
            notifications.push({
                title: i18next.t('CANCEL_ORDER'),
                body: i18next.t(getOrderCancelFailMessage(action.error)),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.SET_DRIVER_SUCCESS:
            notifications.push({
                title: i18next.t('UPDATE_DRIVER'),
                body: i18next.t('DRIVER_SUCCESSFULLY_UPDATED'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.CANCEL_ORDER_SUCCESS:
            notifications.push({
                title: i18next.t('CANCEL_ORDER'),
                body: i18next.t('CANCEL_ORDER_MESSAGE'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.FILTERS_FAILURE:
            notifications.push({
                title: i18next.t('FILTER_ERROR'),
                body: i18next.t('FILTER_UPDATE_ERROR'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.GRID_UPDATE:
            notifications.push({
                title: i18next.t('GRID_DATA_UPLDATED'),
                body: i18next.t('GRID_DATA_UPLDATED'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.REGENERATE_INVOICE_SUCCESS:
            notifications.push({
                title: i18next.t('REGENERATE_INVOICE'),
                body: i18next.t('INVOICE_REGENERATE_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.REGENERATE_INVOICE_FAIL:
            notifications.push({
                title: i18next.t('REGENERATE_INVOICE'),
                body: i18next.t('INVOICE_REGENERATE_ERROR'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_INVOICE_SUCCESS:
            notifications.push({
                title: i18next.t('UPDATE_INVOICE'),
                body: i18next.t('INVOICE_UPDATE_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_INVOICE_FAIL:
            notifications.push({
                title: i18next.t('UPDATE_INVOICE'),
                body: i18next.t('INVOICE_UPDATE_ERROR'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_PAYOUT_SUCCESS:
            notifications.push({
                title: i18next.t('UPDATE_PAYOUT'),
                body: i18next.t('PAYOUT_UPDATE_SUCCESS_MSG'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_PAYOUT_FAIL:
            notifications.push({
                title: i18next.t('UPDATE_PAYOUT'),
                body: i18next.t('PAYOUT_UPDATE_ERROR'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_STOP_EQUIPMENTS_SUCCESS:
            notifications.push({
                title: i18next.t('UPDATE_STOP_EQUIPMENT'),
                body: i18next.t('UPDATE_STOP_EQUIPMENT_SUCCESS_MESSAGE'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_STOP_EQUIPMENTS_FAIL:
            notifications.push({
                title: i18next.t('UPDATE_STOP_EQUIPMENT'),
                body: action.error.message,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.FETCH_ORDER_SHIPMENTS_FAIL:
            notifications.push({
                title: i18next.t('LOAD_ORDER_SHIPMENTS'),
                body: i18next.t('LOAD_ORDER_SHIPMENTS_FAILED_MESSAGE'),
                level: 'error',
            });
            break;
        case ActionTypes.CREATE_ORDER_SHIPMENT_SUCCESS:
            notifications.push({
                title: i18next.t('BOOK_ORDER_SHIPMENT'),
                body: i18next.t('BOOK_ORDER_SHIPMENT_SUCCESS_MESSAGE'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.CREATE_ORDER_SHIPMENT_FAIL:
            notifications.push({
                title: i18next.t('BOOK_ORDER_SHIPMENT'),
                body: action.error,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.CREATE_ORDER_AND_TEMPLATE_SUCCESS:
        case ActionTypes.SAVE_TEMPLATE_AND_BOOK_ORDER_SUCCESS:
            notifications.push({
                title: i18next.t('SAVE_TEMPLATE_AND_BOOK_ORDER'),
                body: i18next.t('TEMPLATE_SAVED_AND_ORDER_CREATED'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_EXCEPTION:
            notifications.push({
                title: i18next.t('UPDATE_EXCEPTION_ON_HOLD'),
                body: i18next.t('EXCEPTION_HOLD_STATUS_UPDATE_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_EXCEPTION_FAIL:
            notifications.push({
                title: i18next.t('UPDATE_EXCEPTION_ON_HOLD'),
                body: i18next.t('EXCEPTION_HOLD_STATUS_UPDATE_FAILURE'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.TRANSITION_SHIPMENT_SUCCESS:
            notifications.push({
                title: i18next.t('SHIPMENT_TRANSITION'),
                body: i18next.t('TRANSITION_SHIPMENT_SUCCESS'),
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.SHARE_SHIPMENT_SUCCESS:
            notifications.push({
                title: i18next.t('SHARE_SHIPMENT'),
                body: i18next.t('SHIPMENT_SHARE_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.TRANSITION_SHIPMENT_FAIL:
            notifications.push({
                title: i18next.t('SHIPMENT_TRANSITION'),
                body: i18next.t('TRANSITION_SHIPMENT_FAIL', { error: action.error }),
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.SHARE_SHIPMENT_FAIL:
            notifications.push({
                title: i18next.t('SHARE_SHIPMENT'),
                body: getSharedShipmentFailMessage(action.error),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.BULK_UPDATE_DATES_SUCCESS: {
            let message = `${i18next.t('SHIPMENTS_UPDATED_COUNT', {
                count: action.response.successes.length,
            })}`;
            if (action.response.errors.length > 0)
                message += `, ${i18next.t('SHIPMENTS_NOT_UPDATED_COUNT', {
                    count: action.response.errors.length,
                })}`;
            notifications.push({
                title: i18next.t('BULK_DATE_UPDATE'),
                body: message,
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_NOTES_SUCCESS: {
            let message = `${i18next.t('SHIPMENTS_UPDATED_COUNT', {
                count: action.response.successes.length,
            })}`;
            if (action.response.errors.length > 0)
                message += `, ${i18next.t('SHIPMENTS_NOT_UPDATED_COUNT', {
                    count: action.response.errors.length,
                })}`;
            notifications.push({
                title: i18next.t('BULK_NOTES_UPDATE'),
                body: message,
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_NOTES_FAIL:
            notifications.push({
                title: i18next.t('BULK_NOTES_UPDATE'),
                body: i18next.t('SHIPMENT_UPDATE_ERROR', {
                    error: action.error.entity.error,
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.BULK_UPDATE_REFERENCE_SUCCESS: {
            const results = ((_c = action === null || action === void 0 ? void 0 : action.response) === null || _c === void 0 ? void 0 : _c.results) || {};
            const processed = results.processed || 0;
            const failures = results.failures || [];
            let message = `${i18next.t('SHIPMENTS_UPDATED_COUNT', {
                count: processed,
            })}`;
            if ((failures === null || failures === void 0 ? void 0 : failures.length) > 0)
                message += `, ${i18next.t('SHIPMENTS_NOT_UPDATED_COUNT', {
                    count: (failures === null || failures === void 0 ? void 0 : failures.length) || 0,
                })}`;
            const level = processed > 0 ? 'success' : 'error';
            notifications.push({
                title: i18next.t('BULK_SHIPMENTS_UPDATE'),
                body: message,
                level: level,
            });
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_REFERENCE_FAIL: {
            const errorMessage = ((_e = (_d = action === null || action === void 0 ? void 0 : action.error) === null || _d === void 0 ? void 0 : _d.entity) === null || _e === void 0 ? void 0 : _e.error) || i18next.t('SERVER_ERROR');
            notifications.push({
                title: i18next.t('BULK_SHIPMENTS_UPDATE'),
                body: i18next.t('SHIPMENT_UPDATE_ERROR', {
                    error: errorMessage,
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_SHIPMENTS_SUCCESS: {
            let message = `${i18next.t('SHIPMENTS_UPDATED_COUNT', {
                count: ((_g = (_f = action === null || action === void 0 ? void 0 : action.response) === null || _f === void 0 ? void 0 : _f.successes) === null || _g === void 0 ? void 0 : _g.length) || 0,
            })}`;
            if (((_j = (_h = action === null || action === void 0 ? void 0 : action.response) === null || _h === void 0 ? void 0 : _h.errors) === null || _j === void 0 ? void 0 : _j.length) > 0)
                message += `, ${i18next.t('SHIPMENTS_NOT_UPDATED_COUNT', {
                    count: ((_l = (_k = action === null || action === void 0 ? void 0 : action.response) === null || _k === void 0 ? void 0 : _k.errors) === null || _l === void 0 ? void 0 : _l.length) || 0,
                })}`;
            notifications.push({
                title: i18next.t('BULK_SHIPMENTS_UPDATE'),
                body: message,
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.BULK_UPDATE_SHIPMENTS_FAIL:
            notifications.push({
                title: i18next.t('BULK_SHIPMENTS_UPDATE'),
                body: i18next.t('SHIPMENT_UPDATE_ERROR', {
                    error: action.error.entity.error,
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.BULK_UPDATE_DATES_FAIL:
            notifications.push({
                title: i18next.t('BULK_DATE_UPDATE'),
                body: i18next.t('SHIPMENT_UPDATE_ERROR', {
                    error: action.error.entity.error,
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RECEIVE_UPDATE_JOBS_CARRIER_SUCCESS:
            notifications.push({
                title: i18next.t('CHANGE_CARRIER'),
                body: i18next.t('CARRIER_UPDATED_FOR_SELECTED_SHIPMENTS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RECEIVE_UPDATE_JOBS_SHIPPER_SUCCESS:
            notifications.push({
                title: i18next.t('CHANGE_SHIPPER'),
                body: i18next.t('SHIPPER_UPDATED_FOR_SELECTED_SHIPMENTS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPSERT_ACI_ZONES_SUCCESS:
            notifications.push({
                title: i18next.t('ADD_ACI_ZONES'),
                body: i18next.t('ACI_ZONES_ADD_UPDATE_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RECEIVE_UPDATE_JOBS_CARRIER_FAIL:
            notifications.push({
                title: i18next.t('CHANGE_CARRIER'),
                body: i18next.t('PROBLEM_UPDATING_CARRIER_FOR_SELECTED_SHIPMENTS'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPSERT_ACI_ZONES_FAIL:
            notifications.push({
                title: i18next.t('ADD_ACI_ZONES'),
                body: i18next.t('ACI_ZONES_ADD_ERROR', { error: action.error }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.BULK_UPDATE_CARRIER_COSTS_SUCCESS:
            notifications.push({
                title: i18next.t('UPDATE_CARRIER_COSTS'),
                body: i18next.t('BULK_UPDATE_CARRIER_COSTS_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.BULK_UPDATE_CARRIER_COSTS_FAIL:
            notifications.push({
                title: i18next.t('UPDATE_CARRIER_COSTS'),
                body: i18next.t('BULK_UPDATE_CARRIER_COSTS_FAIL'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.GET_CUSTOMERS_FAIL:
            notifications.push({
                title: i18next.t('GET_CUSTOMERS'),
                body: `${i18next.t('PROBLEM_RETRIEVING_CUST_DATA')}: ${action.error.message || action.error.cause.message}`,
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.DOWNLOAD_CUSTOMERS_CSV_FAIL:
            notifications.push({
                title: i18next.t('DOWNLOAD_CUSTOMERS_CSV'),
                body: i18next.t('DOWNLOAD_CUSTOMERS_CSV_ERROR', {
                    error: action.error.message || action.error.cause.message,
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.FETCH_CUSTOMER_AUDITS_FAIL:
            notifications.push({
                title: i18next.t('GET_CUSTOMER_AUDITS'),
                body: i18next.t('PROBLEM_RETRIEVING_CUSTOMER_AUDITS'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.ACCEPT_ACCESSORIALS_SUCCESS:
            notifications.push({
                title: i18next.t('ACCESSORIAL_UPDATE'),
                body: i18next.t('ACCESSORIAL_ACCEPTED'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.ACCEPT_ACCESSORIALS_FAIL:
            notifications.push({
                title: i18next.t('ACCESSORIAL_UPDATE'),
                body: i18next.t('ACCESSORIAL_ACCEPT_FAILED'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.CREATE_ACCESSORIAL_REQUEST_SUCCESS:
            notifications.push({
                title: i18next.t('ACCESSORIAL_REQUESTS'),
                body: i18next.t('REQUEST_CREATED'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.CREATE_ACCESSORIAL_REQUEST_FAIL:
            notifications.push({
                title: i18next.t('ACCESSORIAL_REQUESTS'),
                body: i18next.t('ACCESSORIAL_REQ_CREATE_ERROR', {
                    error: humanize(action.err.entity.error),
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.BULK_CREATE_ACCESSORIAL_REQUEST_SUCCESS: {
            const failures = action.result.failures || [];
            if (failures.length) {
                notifications.push({
                    title: i18next.t('ACCESSORIAL_REQUESTS'),
                    body: i18next.t('CREATED_AND_FAILED_REQUESTS', {
                        successCount: action.result.successes.length,
                        failureCount: failures.length,
                    }),
                    level: 'warning',
                });
            }
            else {
                notifications.push({
                    title: i18next.t('ACCESSORIAL_REQUESTS'),
                    body: i18next.t('REQUESTS_CREATED'),
                    level: 'success',
                });
            }
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.BULK_CREATE_ACCESSORIAL_REQUEST_FAIL:
            notifications.push({
                title: i18next.t('ACCESSORIAL_REQUESTS'),
                body: i18next.t('PROBLEM_CREATING_ACCESSORIAL_REQUESTS', {
                    error: humanize(action.err.entity.error),
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.APPROVE_ACCESSORIALS_SUCCESS: {
            let errors = action.response.result.errors;
            if (errors.length) {
                // Success status but with errors in the response
                const amount = action.response.result.successes.length ? 'some' : 'all';
                notifications.push({
                    title: i18next.t('APPROVE_ACCESSORIALS'),
                    body: i18next.t('ACCESSORIALS_UPDATED_EMAIL_NOT_SENT', {
                        amount,
                        error: humanize(errors[0].error),
                    }),
                    level: 'warning',
                });
            }
            else {
                notifications.push({
                    title: i18next.t('APPROVE_ACCESSORIALS'),
                    body: i18next.t('APPROVE_ACCESSORIALS_SUCCESS'),
                    level: 'success',
                });
            }
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.APPROVE_ACCESSORIALS_FAIL:
            notifications.push({
                title: i18next.t('APPROVE_ACCESSORIALS'),
                body: i18next.t('APPROVE_ACCESSORIALS_FAILURE', {
                    error: action.error.message,
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.DECLINE_ACCESSORIALS_SUCCESS: {
            // Note: errors was already declared above.
            let errors = action.response.result.errors;
            if (errors.length) {
                // Success status but with errors in the response
                const slug = action.response.result.successes.length
                    ? 'ACCESSORIAL_UPDATE_CARRIER_SOME_EMAIL_NOT_SENT'
                    : 'ACCESSORIAL_UPDATE_CARRIER_ALL_EMAIL_NOT_SENT';
                notifications.push({
                    title: i18next.t('DECLINE_ACCESSORIALS'),
                    body: i18next.t(slug, { error: humanize(errors[0].error) }),
                    level: 'warning',
                });
            }
            else {
                notifications.push({
                    title: i18next.t('DECLINE_ACCESSORIALS'),
                    body: i18next.t('DECLINE_ACCESSORIALS_SUCCESS'),
                    level: 'success',
                });
            }
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.DECLINE_ACCESSORIALS_FAIL:
            notifications.push({
                title: i18next.t('DECLINE_ACCESSORIALS'),
                body: i18next.t('DECLINE_ACCESSORIALS_FAILURE', {
                    error: action.error.message,
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_ACCESSORIAL_EXCEPTION_SUCCESS:
            notifications.push({
                title: i18next.t('ACCESSORIAL_CHANGE_UPDATE'),
                body: i18next.t('ACCESSORIAL_REQUEST_UPDATED_SUCCESSFULLY'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_ACCESSORIAL_EXCEPTION_FAIL: {
            const { err } = action;
            const errorMessage = ((_m = err === null || err === void 0 ? void 0 : err.entity) === null || _m === void 0 ? void 0 : _m.message) || (err === null || err === void 0 ? void 0 : err.message);
            notifications.push({
                title: i18next.t('ACCESSORIAL_CHANGE_UPDATE'),
                body: i18next.t('ACCESSORIAL_REQUEST_UPDATE_FAILED', {
                    error: errorMessage,
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.UPDATE_ACCESSORIAL_REQUEST_SUCCESS:
            notifications.push({
                title: i18next.t('ACCESSORIAL_REQUESTS'),
                body: i18next.t('ACCESSORIAL_REQUEST_UPDATED_SUCCESSFULLY'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_ACCESSORIAL_REQUEST_FAIL:
            notifications.push({
                title: i18next.t('ACCESSORIAL_REQUESTS'),
                body: i18next.t('ACCESSORIAL_UPDATE_REQUEST_FAILED'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_DELIVERY_ORDER_STATUS_SUCCESS:
            notifications.push({
                title: i18next.t('UPDATE_DELIVERY_ORDER_STATUS'),
                body: i18next.t('UPDATE_DELIVERY_ORDER_STATUS_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_DELIVERY_ORDER_STATUS_FAIL:
            notifications.push({
                title: i18next.t('UPDATE_DELIVERY_ORDER_STATUS'),
                body: i18next.t('UPDATE_DELIVERY_ORDER_STATUS_FAILURE', {
                    error: JSON.stringify(action.error),
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RECEIVE_DRAYAGE_OFFER_SUCCESS:
            notifications.push({
                title: i18next.t('OFFER_SENT'),
                body: i18next.t('OFFER_SENT_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RECEIVE_DRAYAGE_OFFER_FAIL:
            notifications.push({
                title: i18next.t('FAILED_TO_SEND_OFFER'),
                body: i18next.t('SEND_OFFER_FAILED'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPLOAD_ACCESSORIAL_DOC_SUCCESS:
            notifications.push({
                title: i18next.t('ACCESSORIAL_REQUESTS'),
                body: i18next.t('DOCUMENT_ADDITION_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPLOAD_ACCESSORIAL_DOC_FAIL:
            notifications.push({
                title: i18next.t('ACCESSORIAL_REQUESTS'),
                body: i18next.t('DOCUMENT_ADDITION_FAILURE'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RECEIVE_SHIPMENT_CLONE_SUCCESS:
            notifications.push({
                title: i18next.t('CLONE_SHIPMENT'),
                body: i18next.t('SHIPMENT_CLONED_SUCCESSFULLY'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RECEIVE_DELETE_LOCATION:
            notifications.push({
                title: i18next.t('DELETE_LOCATION'),
                body: i18next.t('LOCATION_DELETE_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.PASSWORD_RESET_REQUEST_SUCCESS:
            notifications.push({
                title: i18next.t('PASSWORD_RESET'),
                body: i18next.t('PASSWORD_RESET_LINK_SENT'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.PASSWORD_CHANGE_SUCCESS:
            notifications.push({
                title: i18next.t('PASSWORD_CHANGE_SUCESS'),
                body: i18next.t('NEW_PASSWORD_CREATED'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RERATE_SHIPMENT_COSTS_SUCCESS: {
            const updateResults = action.response.updateResults;
            const successMessageMapping = {
                shipper: 'RERATE_COSTS_SUCCESS_SHIPPER',
                carrier: 'RERATE_COSTS_SUCCESS_CARRIER',
                shipper_fsc: 'RERATE_COSTS_SUCCESS_SHIPPER_FSC',
                carrier_fsc: 'RERATE_COSTS_SUCCESS_CARRIER_FSC',
            };
            const errorMessageMapping = {
                shipper: 'RERATE_COSTS_FAIL_SHIPPER',
                carrier: 'RERATE_COSTS_FAIL_CARRIER',
                shipper_fsc: 'RERATE_COSTS_FAIL_SHIPPER_FSC',
                carrier_fsc: 'RERATE_COSTS_FAIL_CARRIER_FSC',
            };
            const notificationData = updateResults.reduce((finalUpdate, update) => {
                const customer_type = update.cost;
                const successMessage = successMessageMapping[customer_type];
                const errorMessage = errorMessageMapping[customer_type];
                if (update.result) {
                    finalUpdate.notificationColor =
                        finalUpdate.notificationColor === 'error' ? 'warning' : 'success';
                    finalUpdate.notificationText =
                        finalUpdate.notificationText + i18next.t(successMessage) + '\n';
                }
                else {
                    finalUpdate.notificationText =
                        finalUpdate.notificationText +
                            i18next.t(errorMessage, { reason: humanize(update.reason) }) +
                            '\n';
                }
                return finalUpdate;
            }, {
                notificationColor: 'error',
                notificationText: '',
            });
            notifications.push({
                title: i18next.t('RERATE_COSTS'),
                body: notificationData.notificationText,
                level: notificationData.notificationColor,
            });
            ToastStore.emitChange();
            break;
        }
        case ActionTypes.RERATE_SHIPMENT_COSTS_FAILURE:
            notifications.push({
                title: i18next.t('RERATE_COSTS'),
                body: i18next.t('RERATE_COSTS_FAIL_DEFAULT'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_ORDER_SUCCESS:
            notifications.push({
                title: i18next.t('ORDER_UPDATE'),
                body: i18next.t('ORDER_UPDATE_SUCCESS'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.UPDATE_ORDER_FAIL:
            notifications.push({
                title: i18next.t('ORDER_UPDATE'),
                body: i18next.t('SERVICE_TYPE_UPDATE_FAIL'),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.RECEIVE_UPDATE_JOBS_CONSIGNEE_SUCCESS:
            showToast(i18next.t('CHANGE_CONSIGNEE'), i18next.t('CONSIGNEE_UPDATED_FOR_SELECTED_SHIPMENTS'));
            break;
        case ActionTypes.RECEIVE_UPDATE_JOBS_CONSIGNEE_FAIL:
            showToast(i18next.t('CHANGE_CONSIGNEE'), i18next.t('PROBLEM_UPDATING_CONSIGNEE_FOR_SELECTED_SHIPMENTS'), 'error');
            break;
        case ActionTypes.ADD_ORDER_COMMENT_SUCCESS:
            notifications.push({
                title: i18next.t('COMMENT_UPDATED_SUCCESSFULLY'),
                body: i18next.t('COMMENT_UPDATED_SUCCESSFULLY'),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.ADD_ORDER_COMMENT_FAIL:
            notifications.push({
                title: i18next.t('COMMENT_UPDATE_FAILED'),
                body: i18next.t('COULDNT_UPDATE_COMMENT', { message: '' }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.DRIVER_MANIFEST_DEPART_SUCCESS:
            notifications.push({
                title: i18next.t('DRIVER_MANIFEST_SUCCESS'),
                body: i18next.t('DRIVER_MANIFEST_DEPARTED_SUCCESS', { message: '' }),
                level: 'success',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.DRIVER_MANIFEST_DEPART_FAIL:
            notifications.push({
                title: i18next.t('DRIVER_MANIFEST_FAIL'),
                body: i18next.t('DRIVER_MANIFEST_DEPARTED_FAIL', {
                    message: action.message,
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        case ActionTypes.DRIVER_MANIFEST_ALREADY_DEPART_ERROR:
            notifications.push({
                title: i18next.t('DRIVER_MANIFEST_ERROR'),
                body: i18next.t('DRIVER_MANIFEST_ALREADY_DEPARTED', {
                    message: action.message,
                }),
                level: 'error',
            });
            ToastStore.emitChange();
            break;
        default:
            break;
    }
});
export default ToastStore;
